import React from 'react';
import PropTypes from 'prop-types';
import { withFormsy } from 'formsy-react';
import uniqueId from 'lodash.uniqueid';

import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';

class RawTextfieldInput extends React.Component {
  constructor(props) {
    super(props);

    this.id = uniqueId();
    this.changeValue = this.changeValue.bind(this);
  }

  changeValue(event) {
    this.props.setValue(event.currentTarget.value);
  }

  render() {
    return (
      <Grid container className={ this.props.className }>
        <Grid item xs={12}>
          <FormControl error={ this.props.showError() } style={{ width: "100%" }}>
            <InputLabel htmlFor={ `textfield-input-${this.id}` }>
              { this.props.showError() ? this.props.getErrorMessage() : this.props.label }
            </InputLabel>
            <Input
              id={ `textfield-input-${this.id}` }
              value={ this.props.getValue() || "" }
              onChange={ this.changeValue }
              { ...this.props.elementProps }
            />
          </FormControl>
        </Grid>
      </Grid>
    );
  }
}

RawTextfieldInput.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
}

export default withFormsy(RawTextfieldInput);

